export default function FooterSection() {
  return (
    <footer
      data-testid="footer-section"
      className="py-10 px-6 sm:px-12 lg:px-24 border-t border-neutral-800 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-neutral-500 text-sm">
          &copy; {new Date().getFullYear()} AnyWash Pass. All rights reserved.
        </p>
        <div className="flex items-center gap-6">
          <a href="#what-is" className="text-neutral-500 hover:text-white text-sm transition-colors">About</a>
          <a href="#how-it-works" className="text-neutral-500 hover:text-white text-sm transition-colors">How It Works</a>
          <a href="#contact" className="text-neutral-500 hover:text-white text-sm transition-colors">Contact</a>
        </div>
      </div>
    </footer>
  );
}
